import { BaseText, Meta } from 'aimo-ui';
import TextWithLinks, { TextLink } from 'components/common/TextWithLinks';
import React from 'react';
import styled from 'styled-components/native';
import { useUiStore } from 'stores/uiStore';

export type ApproveTermsType = 'Location' | 'Updated';

type ApproveTermsTextProps = { type?: ApproveTermsType };

const links: Record<string, TextLink> = {
  privacyPolicy: {
    onPress: () => useUiStore.getState().setSheetModal('privacyPolicy'),
  },
  termsAndConditions: {
    onPress: () => useUiStore.getState().setSheetModal('termsAndConditions'),
  },
};

const StyledBaseText = styled(BaseText)`
  color: ${(p) => p.theme.colors.black};
  flex-shrink: 1;
`;

const StyledMetaText = styled(Meta)`
  color: ${(p) => p.theme.colors.gray300};
  flex-shrink: 1;
`;

const ApproveTermsText: React.FC<ApproveTermsTextProps> = ({ type }) => {
  const StyledText = type ? StyledBaseText : StyledMetaText;

  return (
    <StyledText>
      <TextWithLinks
        i18nKey={`account.terms.newPrivacyPolicyAndTermsConditionsInfo${
          type ?? ''
        }`}
        links={links}
      />
    </StyledText>
  );
};

export default ApproveTermsText;
